﻿﻿import { ProspectStatus } from '../enums/index';

export interface IProductStatusRequest {
    id: number;
    description: string;
    prospectStatus: ProspectStatus;
    color: string;
    textColor: string;
}
